/**
 * Settings Modal for VariationImgImgText
 * Migrated to use shared SettingsModal pattern
 * Before: 161 lines | After: ~40 lines
 */
import { FC } from 'react';

import { ImageData } from '../VariationOne';
import { DIVIDERS, TEXT_POSITIONS } from '../VariationOne/SettingsModal';
import {
  SettingsModal as SharedSettingsModal,
  WATERMARK_SECTIONS,
  withWatermarkDefaults,
} from '../shared';

interface Props {
  image: ImageData;
  type: 'left' | 'right';
  imageIndex: number;
  onClose: () => void;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
}

const SettingsModal: FC<Props> = ({ type, image, ...props }) => (
  <SharedSettingsModal
    {...props}
    image={withWatermarkDefaults(image)}
    title="Image Parameters"
    sections={[
      {
        title: 'Text Position',
        type: 'radio',
        stateKey: 'textPosition',
        options: TEXT_POSITIONS,
        show: type === 'left',
      },
      ...WATERMARK_SECTIONS,
      {
        title: 'Cover Divider',
        type: 'radio',
        stateKey: 'divider',
        options: DIVIDERS,
        show: type === 'left',
      },
    ]}
  />
);

export default SettingsModal;
